module.exports = __webpack_public_path__ + "static/media/bg_package_lt.d6bdbcca.png";